import { TIPO_CERTIFICADOS } from "../../../utils/constants";

export const formCud = (initialValues) => ({
    idAfiliado: initialValues.afiliado.id_afiliado,
    idEntidadEmision: "",
    diagnosticos: [],
    prestacionesCubiertas: "",
    // idTipoDiscapacidad: "", //
    // idFrecuenciaDiscapacidad: "", //
    // idAlcanceDiscapacidad: "", //
    observaciones: "", //
    acompanante: false,
    nombrePadreMadreTutor: "",
    email: "",
    celular: ""
});

export const certificadoForm = (initialValues) => ({
    idAfiliado: initialValues.idAfiliado,
    tipoCertificado: TIPO_CERTIFICADOS.DISCAPACIDAD,
    fecha: initialValues.certificadoDiscapacidad
        ? initialValues.certificadoDiscapacidad?.fecha
        : "",
    fechaNacimiento: initialValues.certificadoDiscapacidad
        ? initialValues.certificadoDiscapacidad?.fechaNacimiento
        : "",
    fechaRealParto: initialValues.certificadoDiscapacidad
        ? initialValues.certificadoDiscapacidad?.fechaRealParto
        : "",
    fechaProbableParto: initialValues.certificadoDiscapacidad
        ? initialValues.certificadoDiscapacidad?.fechaProbableParto
        : "",
    fechaVencimiento: initialValues.certificadoDiscapacidad
        ? initialValues.certificadoDiscapacidad?.fechaVencimiento
        : "",
    fecha2doVencimiento: initialValues.certificadoDiscapacidad
        ? initialValues.certificadoDiscapacidad?.fecha2doVencimiento
        : "",
    fechaActualizacion: initialValues.certificadoDiscapacidad
        ? initialValues.certificadoDiscapacidad?.fechaActualizacion
        : "",
    madreHijo: initialValues.certificadoDiscapacidad
        ? initialValues.certificadoDiscapacidad?.madreHijo
        : "",
});